'use strict';

/** @type {import('./range')} */
module.exports = RangeError;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/range.js
// module id = 67
// module chunks = 114276838955818 131683993344931 142807904292071 184470312924441